import React from 'react'
import Select from 'react-select'

const customStyles = (theme) => ({
  control: (styles, state) => {
    const openedControleStyles = state.selectProps.menuIsOpen
      ? {
        boxShadow: '0px 6px 27px 0px rgba(0,0,0,0.09)',
        borderRadius: '31.5px 31.5px 0 0',
        border: 'unset'
      }
      : {}
    return ({
      ...styles,
      zIndex: 3,
      width: theme.width || 309,
      height: theme.height || 63,
      boxShadow: '0px 6px 27px 0px rgba(0,0,0,0.09)',
      borderRadius: '31.5px',
      '@media only screen and (max-width: 576px)': {
        ...styles['@media only screen and (max-width: 576px)'],
        height: 45
      },
      ...(theme || {}),
      ...openedControleStyles,
    })
  },
  singleValue: (styles) => ({
    ...styles,
    fontWeight: 'bold'
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: '2px 20px'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  dropdownIndicator: (styles, state) => {
    const openedStyles = state.selectProps.menuIsOpen
    ? {
        backgroundColor: 'unset',
        backgroundImage: 'linear-gradient(0.0deg, #1a7fc8 0%, #209ef7 100%)',
        borderColor: '#209ef7'
      }
    : {}

    return {
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : '',
      color: state.selectProps.menuIsOpen ? '#fff' : 'hsl(0, 0%, 80%)',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '50%',
      border: '1px solid #b4b4b4',
      opacity: 0.52,
      padding: theme ? 12 : 14.5,
      margin: '2px 5px',
      ...openedStyles,

      '@media only screen and (max-width: 576px)': {
        ...styles['@media only screen and (max-width: 576px)'],
        padding: 5,
      }
    }
  },
  indicatorsContainer: (styles, state) => {
    return ({
      ...styles,
      display: 'flex',
      alignItems: 'center',
    })
  },
  menu: (styles, state) => {
    const menuStyles = state.selectProps.menuIsOpen
      ? {
        border: 'unset',
        borderRadius: '0 0 31.5px 31.5px',
        marginTop: '0px',
        width: theme.width || '309px',
        padding: '5px 20px 20px 20px',
        boxShadow: '0px 6px 7px 0px rgb(0 0 0 / 9%)',
        zIndex: 4,
      }
      : {}
    return ({
      ...styles,
      ...menuStyles
    })
  },
  option: (styles) => ({
    ...styles,
    paddingBottom: '10px',
    borderBottom: '1px solid #d4d4d4',
    fontWeight: 'bold'
  })
})

const labelStyles = {
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: 500,
  color: '#373a3f',
  marginBottom: '5px'
}

const SelectField = (props) => {
  const { label, id, theme } = props
  return label
    ? (
      <div className='flex-container--column select-field'>
        <label style={labelStyles} htmlFor={id}>{label}</label>
        <Select
          {...props}
          styles={customStyles(theme || {})}
          onChange={(option) => {
            props.onChange(option || { label: null, value: null })
          }}
        />
      </div>
    )
    : <Select
        {...props}
        styles={customStyles(theme || {})}
        onChange={(option) => {
          props.onChange(option || { label: null, value: null })
        }}
      />
  }

export default SelectField
